import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  BButton,
  BModal,
  BForm,
  BFormInput,
  BFormGroup,
  BImg
} from 'bootstrap-vue';
import {
  ValidationProvider,
  ValidationObserver
} from 'vee-validate/dist/vee-validate.full';
import CustomLabel from '@/@core/components/labels/CustomLabel.vue';

@Component({
  components: {
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BForm,
    BImg,
    ValidationProvider,
    ValidationObserver,
    CustomLabel
  }
})
export default class OtherServicePriceFormModal extends Vue {
  $refs!: {
    formRules: InstanceType<typeof ValidationProvider>;
    modal: InstanceType<typeof BModal>;
  };
  quantity?: number = undefined;
  index?: number = 0;

  openCreateModal(): void {
    this.quantity = undefined;
    this.index = undefined;
    this.$refs.modal.show();
  }

  openEditModal(quantity: number, index: number): void {
    this.quantity = quantity;
    this.index = index;
    this.$refs.modal.show();
  }

  submit() {
    this.$refs.formRules.validate().then((success) => {
      if (success) {
        this.$emit('submit', this.quantity, this.index);
      }
    });
  }
}
